import { useTranslation } from 'react-i18next'
import { Phone, Mail, Contact as ContactIcon } from 'lucide-react'

interface DeviceContact {
  name?: string[]
  tel?: string[]
  email?: string[]
}

interface DeviceContactsListProps {
  contacts: DeviceContact[]
  onSelectContact: (contact: DeviceContact) => void
}

export function DeviceContactsList({ 
  contacts, 
  onSelectContact 
}: DeviceContactsListProps) {
  const { t } = useTranslation()

  return (
    <div className="space-y-2">
      <p className="text-sm text-text-secondary mb-4">
        {t('contacts.selectDeviceContact', 'Selecione um contacto do seu telemóvel')}
      </p>
      {contacts.map((deviceContact, index) => {
        const name = (deviceContact.name?.[0] || t('contacts.unknown', 'Desconhecido')).toString()
        const phone = (deviceContact.tel?.[0] || '').toString()
        const emailValue = (deviceContact.email?.[0] || '').toString()
        
        return (
          <button
            key={index}
            onClick={() => onSelectContact(deviceContact)}
            className="w-full p-4 text-left bg-gray-50 hover:bg-gray-100 rounded-xl transition-colors border border-gray-200"
          >
            <div className="flex items-center space-x-3">
              <ContactIcon className="h-8 w-8 text-primary" />
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-text-primary truncate">
                  {name}
                </h3>
                {phone && (
                  <p className="text-sm text-text-secondary">
                    <Phone className="h-3 w-3 inline mr-1" />
                    {phone}
                  </p>
                )}
                {emailValue && (
                  <p className="text-sm text-text-secondary">
                    <Mail className="h-3 w-3 inline mr-1" />
                    {emailValue}
                  </p>
                )}
              </div>
            </div>
          </button>
        )
      })}
    </div>
  )
}

